var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.index+1)+". "+_vm._s(_vm.event.title))]),_vm._v(" "),_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.dateTimeFormatter(Date.parse(new Date(_vm.event.date)),_vm.i18n[_vm.locale].fullFormat)))]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.event.desc))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ec9ca6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/calendar/components/cal-event-item.vue
// module id = xm2F
// module chunks = 0